import { render } from "./main_culinary.vue?vue&type=template&id=861fb12c"
import script from "./main_culinary.vue?vue&type=script&lang=js"
export * from "./main_culinary.vue?vue&type=script&lang=js"

import "./main_culinary.vue?vue&type=style&index=0&id=861fb12c&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__